import React from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"
import styled from "styled-components"
import BeatLoader from "react-spinners/dist/spinners/BeatLoader"

const spinnerSize = 10
const spinnerMargin = 2
const spinnerCalculatedWidth = (spinnerSize * 3) + (spinnerMargin * 6) // prettier-ignore

const Wrapper = styled.div`
  text-align: center;
  padding: 10px 0 20px 0;
  height: ${spinnerSize}px;
  position: relative;
`

const SpinnerContainer = styled.div`
    margin: auto;
    position: absolute;
    top: 10px;
    left: 0;
    bottom: 20px;
    right: 0;
    width: ${spinnerCalculatedWidth}px;
    height: ${spinnerSize + (spinnerMargin * 2)}px; 
  ` // prettier-ignore

/** The loading spinner to display whilst a particular filter field is having its values loaded */
function FilterLoadingSpinner({ theme }) {
  const defaultSpinnerColor = "#513b8b"
  const spinnerColor = theme.primaryColor || defaultSpinnerColor

  return (
    <Wrapper>
      <SpinnerContainer>
        <BeatLoader loading color={spinnerColor} size={spinnerSize} margin={`${spinnerMargin}px`} />
      </SpinnerContainer>
    </Wrapper>
  )
}

FilterLoadingSpinner.propTypes = {
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(connect(mapStateToProps))(FilterLoadingSpinner)



// WEBPACK FOOTER //
// ./src/components/filters/FilterLoadingSpinner.jsx